export default {
  // Grey general note (restored per PM video) — the full one-per-order rule, shown on the
  // offer sheet and the promo/gift modal. Automatic discounts (smart pricing) still stack.
  general_note:
    'Rabatkoder og gavekort kan ikke kombineres med andre rabatter. Et tilbud og indløsning af point kan bruges sammen. Automatiske rabatter som afhentningsrabatten gælder stadig.',
  // Full note — offer detail sheet + promo/gift entry (CTO shortened to one line, 2026-07-31).
  full_note: 'Rabatkoder og gavekort kan ikke kombineres med andre rabatter.',
  // Green status pill on the offer sheet when the offer's requirement is met (prototype).
  unlocked: 'Låst op',
  // Short static exclusion note per surface (card footers, CTO-confirmed copy).
  footer: {
    offer: 'Kan ikke kombineres med rabatkoder eller gavekort.',
    promo: 'Kan ikke kombineres med tilbud, gavekort eller point.',
    gift: 'Kan ikke kombineres med tilbud, rabatkoder eller point.',
  },
  // State-aware conflict line — names the discount that will be displaced.
  // Full mutual exclusivity (PM video): offer, promo, gift and points all block each other.
  conflict: {
    offer_blocked_by_promo: 'En rabatkode er anvendt. Hvis du bruger dette tilbud, fjernes den.',
    offer_blocked_by_gift: 'Et gavekort er anvendt. Hvis du bruger dette tilbud, fjernes det.',
    offer_blocked_by_points: 'En indløsning af point er aktiv. Hvis du bruger dette tilbud, fjernes den.',
    promo_gift_displaces_offer: 'Hvis du bruger en rabatkode eller et gavekort, fjernes dit aktive tilbud.',
    promo_gift_displaces_points: 'Hvis du bruger en rabatkode eller et gavekort, fjernes din indløsning af point.',
    promo_gift_displaces_offer_and_points:
      'Hvis du bruger en rabatkode eller et gavekort, fjernes dit aktive tilbud og din indløsning af point.',
  },
  // Comparison-choice card (Inc 4, FOO-2567) — offer / promo detail modals when a conflicting
  // discount is already applied. Lets the customer pick, flagging the higher saving as best.
  comparison: {
    active_line: 'Allerede aktiv ({{kind}}): {{name}} ({{saving}}).',
    active_line_no_saving: 'Allerede aktiv ({{kind}}): {{name}}.',
    candidate_line: 'Med {{kind}} sparer du {{saving}}.',
    only_one: 'Du kan kun bruge én.',
    best_choice: 'Bedste valg',
    keep: 'Behold {{label}}',
    use_instead: 'Brug {{label}} i stedet',
    kinds: {
      offer: 'tilbud',
      promo: 'rabatkode',
      gift: 'gavekort',
      points: 'indløsning af point',
    },
    // Concise nouns for the Keep/Use buttons ("Keep offer", "Use code instead").
    button_kinds: {
      offer: 'tilbud',
      promo: 'kode',
      gift: 'gavekort',
      points: 'point',
    },
    // Single-action variant (offer modal, promo/gift already active): one sentence + only the
    // "Use offer instead" button — closing the window keeps the code (CTO 2026-08-03).
    single_message:
      '{{active}} er allerede aktiv. Kun én rabat kan bruges pr. ordre — brug dette tilbud i stedet, eller luk vinduet for at beholde din kode.',
    active_named: {
      promo: 'Rabatkode {{name}} ({{saving}})',
      gift: 'Gavekort ({{saving}})',
    },
    active_named_no_saving: {
      promo: 'Rabatkode {{name}}',
      gift: 'Gavekort',
    },
    // Multiple active offers (item 6) — promo modal comparison, replaces the active/candidate lines.
    active_offers_two:
      'Du har {{count}} aktive tilbud: {{first}} ({{firstValue}}) og {{second}} ({{secondValue}}) — {{total}} i alt. Rabatkoden {{code}} sparer {{codeValue}} på denne ordre. Kun én kan bruges.',
    active_offers_more:
      'Du har {{count}} aktive tilbud: {{first}} ({{firstValue}}), {{second}} ({{secondValue}}) og {{more}} mere — {{total}} i alt. Rabatkoden {{code}} sparer {{codeValue}} på denne ordre. Kun én kan bruges.',
  },
  // Discount-card status tag (deals carousel — offer + promo cards), Inc 3.
  card: {
    available: 'Tilgængelig nu',
    applied: 'Anvendt · {{savings}} rabat',
    applied_plain: 'Anvendt',
    replaces: 'Kan ikke kombineres med {{label}} · Erstatter {{name}}',
    replaces_no_name: 'Kan ikke kombineres med {{label}}',
    // Prototype card treatment (blocked-by-conflict): a warning line naming the active discount,
    // the one-per-order note, and a "Replaces …" line.
    cannot_combine: 'Kan ikke kombineres med {{name}}',
    replaces_name: 'Erstatter {{name}}',
    // Multiple active offers (n>1) — show a count + total instead of a single offer name (item 6).
    cannot_combine_offers: 'Kan ikke kombineres med dine {{count}} aktive tilbud',
    replaces_offers: 'Erstatter {{count}} aktive tilbud ({{total}})',
    // Generic type label for the active discount that would be displaced.
    kind: {
      offer: 'et tilbud',
      promo: 'en rabatkode',
      gift: 'et gavekort',
      points: 'din indløsning af point',
    },
  },
  // DisplacementNotice (cart drawer + checkout) — bidirectional & entity-named (PM video).
  // One discount displaced another; the message names both, and Undo restores the displaced one.
  // e.g. "Promo code CHEVERE applied. This removed the 2-für-1 offer. [Undo]".
  displacement: {
    message: '{{applied}} anvendt. Dermed blev {{removed}} fjernet.',
    // Multiple offers removed at once (item 6) — names the top two + the total, in cart + checkout.
    offer_removed_multi: {
      promo:
        'Rabatkoden {{code}} ({{codeValue}}) er anvendt. Dermed blev {{count}} tilbud fjernet: {{first}} og {{second}} ({{total}}).',
      gift: 'Gavekort anvendt. Dermed blev {{count}} tilbud fjernet: {{first}} og {{second}} ({{total}}).',
    },
    undo: 'Fortryd',
    // The discount that is currently applied (the "winner").
    applied: {
      offer: 'Tilbud {{name}}',
      promo: 'Rabatkode {{code}}',
      gift: 'Gavekort',
      points: '{{count}} point',
    },
    // The discount that was displaced (the "loser"), restored by Undo.
    removed: {
      offer: 'tilbuddet {{name}}',
      promo: 'rabatkoden {{code}}',
      gift: 'gavekortet',
      points: 'din indløsning af point',
    },
    // UX feedback item 3 — points redemption displacing a promo/gift. Layer A: a zero-friction hint
    // under the "Use your points" header, shown only while a code/gift is active (before they tap).
    points_hint: {
      promo: 'Hvis du bruger point, fjernes rabatkode {{name}} (–{{saving}})',
      gift: 'Hvis du bruger point, fjernes gavekortet (–{{saving}})',
      promo_no_saving: 'Hvis du bruger point, fjernes rabatkode {{name}}',
      gift_no_saving: 'Hvis du bruger point, fjernes gavekortet',
    },
    // Layer B: the post-action displacement notice, extended to the points→code direction.
    points_displaced: {
      promo: '{{points}} point anvendt (–{{pointsSaving}}). Rabatkode {{name}} (–{{couponSaving}}) blev fjernet.',
      gift: '{{points}} point anvendt (–{{pointsSaving}}). Gavekort (–{{couponSaving}}) blev fjernet.',
      promo_no_saving: '{{points}} point anvendt (–{{pointsSaving}}). Rabatkode {{name}} blev fjernet.',
      gift_no_saving: '{{points}} point anvendt (–{{pointsSaving}}). Gavekortet blev fjernet.',
    },
  },
};
